const UserTypeEnum = {
  1: 'Interno',
  2: 'Cliente',
  3: 'Parceiro',
  4: 'Motorista',
  5: 'Filial'
}

export default UserTypeEnum;
